import { createContext } from "react";
import { AuthUser } from "../api/common";

//set initial value of user to null (pre-login)
export const UserContext = createContext<AuthUser | undefined>(undefined);
